export var ReportType;
(function (ReportType) {
    ReportType["DAILY_TEMPERATURE_REPORT"] = "DAILY_TEMPERATURE_REPORT";
})(ReportType || (ReportType = {}));
export const ReportTypeLabel = {
    [ReportType.DAILY_TEMPERATURE_REPORT]: 'Daily Temperature Record',
};
export const ReportTypeSteps = {
    [ReportType.DAILY_TEMPERATURE_REPORT]: [
        'Setup Temperature Checks',
        'Select Equipment',
        'Summary',
    ],
};
